/**
 * @description Supports the shift from "promotions" to "folders" url patterns
 * by building a redirect (backbone.router.navigate) url for rewrite purposes 
 */

 export const folderRouteBuilder = (folderId, action = null, type = null, id = null) => {
	let folderUrl = '#!/folders'
	folderUrl += folderId ? `/${folderId}` : ''
	folderUrl += action ? `/${action}` : ''
	folderUrl += type ? `/${type}` : ''
	folderUrl += id ? `/${id}` : ''
	
	return folderUrl
 }
